<template>
  <div class="profile-section">
    <profile-item
      v-for="(metadata, index) in fieldMetadata"
      :metadata="metadata"
      :key="index"
      :field-props="metadata.fieldProps"
    ></profile-item>
  </div>
</template>

<script>
import ProfileItem from "./ProfileItem";
export default {
  name: "ProfileSection",
  props: {
    fieldMetadata: Array,
    saver: Function
  },
  components: { ProfileItem },
  methods: {},
  data() {
    return {
      students: this.initialStudents
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
